import gql from "graphql-tag";

export const DOCUMENT_VIEWERFIELDS = gql`
  fragment DocumentViewerFields on Document {
				id
				created
				identifier
				status
				description
				comment
				files {
					id
					name
					extension
					deleted
					type
					groupId
					parentGroupId,
					timeStamp
				}
				metaData {
					documentId,
					id
					key
					value
					timeStamp
					valueType
					selected
					confidence
					source
					changed
				}
  }
`;
